import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const PlusIcon = createIcon({
  displayName: 'PlusIcon',
  path: [<path d='M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2h6Z' fill='currentColor' />],
  defaultProps: defaultProps
})
